import {
  FETCH_REFILL_LIST,
  RESET_REFILL_LIST,
} from "../../constants/action.constants";
import { getAccessToken } from "../../services/browserStorage";
import { webApiCheck } from "../../services/commonMethods";
import { postDashboardWebApi } from "../../webApis/apiResource";

export const requestRefillList = (urlEndPoint, payload) => {
  return async (dispatch) => {
    const response = await postDashboardWebApi(
      getAccessToken(),
      urlEndPoint,
      payload
    );
    if (webApiCheck(response)) {
      dispatch(fetchRefillList(response.data, payload));
    }
  };
};

const fetchRefillList = (resp, payload) => {
  const { data, ...others } = resp;
  return {
    type: FETCH_REFILL_LIST,
    payload: { data, payload: payload.payload },
    others,
  };
};

export const resetRefillList = () => {
  return {
    type: RESET_REFILL_LIST,
  };
};
